import { Component, Element, State, h } from '@stencil/core';
import state from '../../store';
import { hideField } from '../../utils/form';
import { scrollToTop } from '../../utils/scroll';

@Component({
  tag: 'hemfixarna-address',
  shadow: false,
})
export class HemfixarnaAddress {
  @State() street: string = '';
  @State() streetError: string | null = null;
  @State() zip: string = '';
  @State() zipError: string | null = null;
  @State() town: string = '';
  @State() townError: string | null = null;
  @Element() private el: HTMLElement;

  componentWillLoad() {
    if (state.user) {
      this.street = state.user.street;
      this.zip = state.user.zip;
      this.town = state.user.town;
    }
  }

  handleSubmit = (e: Event) => {
    e.preventDefault();
    const streetValid = this.street.length > 0;
    if (!streetValid) {
      this.streetError = 'Ange en gatuadress';
    }
    const zipValid = this.zip.length > 0;
    const zipIsNumber = /^\s*\d[\d\s]*$/.test(this.zip);
    if (!zipIsNumber) {
      this.zipError = 'Postnummer får endast innehålla siffror';
    }
    if (!zipValid) {
      this.zipError = 'Ange ett postnummer';
    }
    const townValid = /^[^\d\s]{2,}$/.test(this.town);
    if (!townValid) {
      this.townError = 'Ange en ort';
    }
    if (streetValid && zipValid && townValid && zipIsNumber) {
      state.user = { ...state.user, street: this.street, zip: this.zip, town: this.town };
      state.checkoutStep = 2;
      state.checkoutEdit = false;
      const el = this.el.closest('.hemfixarna_content');
      scrollToTop(el);
    }
  };

  handleChangeStreet = (e: Event) => {
    this.streetError = null;
    this.street = this.street === state.user.street ? '' : (e.target as HTMLInputElement).value;
  };

  handleChangeZip = (e: Event) => {
    this.zipError = null;
    this.zip = this.zip === state.user.zip ? '' : (e.target as HTMLInputElement).value;
  };

  handleChangeTown = (e: Event) => {
    this.townError = null;
    this.town = this.town === state.user.town ? '' : (e.target as HTMLInputElement).value;
  };

  render = () => {
    return (
      <form class="hemfixarna_address" onSubmit={e => this.handleSubmit(e)}>
        <div>
          <input
            class={`${this.street.length ? 'input_active' : ''}`}
            onInput={this.handleChangeStreet}
            type="text"
            name="street"
            value={this.street === state.user.street ? hideField(this.street) : this.street}
          />
          <label htmlFor="street">Gatuaddress </label>
        </div>
        {this.streetError && <span>{this.streetError}</span>}
        <div>
          <input
            class={`${this.zip.length ? 'input_active' : ''}`}
            onInput={this.handleChangeZip}
            type="tel"
            name="zip"
            value={this.zip === state.user.zip ? hideField(this.zip) : this.zip}
          />
          <label htmlFor="zip">Postnummer </label>
        </div>
        {this.zipError && <span>{this.zipError}</span>}
        <div>
          <input
            class={`${this.town.length ? 'input_active' : ''}`}
            onInput={this.handleChangeTown}
            type="text"
            name="town"
            value={this.town === state.user.town ? hideField(this.town) : this.town}
          />
          <label htmlFor="town">Ort </label>
        </div>
        {this.townError && <span>{this.townError}</span>}
        <input type="submit" value="Fortsätt" />
      </form>
    );
  };
}
